<template>
  <div class="banner-leaseback">
    <span class="banner-leaseback__badge">Nuevo</span>
    <span class="banner-leaseback__texto">¿Necesitas liquidez? Obtén hasta UF 40.000 sin vender tu propiedad</span>
    <!-- Link HTML real (no router) a la landing, igual que el navbar (ver claude.md §11 y §12) -->
    <a class="banner-leaseback__link" href="https://sitios.redcapital.cl/leaseback">Conoce el Leaseback &rarr;</a>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class BannerLeaseback extends Vue {}
</script>

<style lang="scss" scoped>
.banner-leaseback {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 4px 16px;
  padding: 8px 16px;
  background-color: #FFF3E2;
  color: #3D3D3D;
  // Va fuera de .rc-view/.active-menu, que son los que dan la fuente al sitio; sin esto hereda Nunito Sans del v-app
  font-family: $rc-font-sf;
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  line-height: 1.4;
}
.banner-leaseback__badge {
  // Gris y no naranja: blanco sobre $rc-prim-n1 daba 2,36:1 y el mínimo es 4,5:1 (ver claude.md §18)
  background-color: #3D3D3D;
  color: #fff;
  border-radius: 999px;
  padding: 2px 10px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.banner-leaseback__link {
  // Naranja oscurecido solo aquí: $rc-prim-n1 sobre el fondo crema daba 2,16:1 (ver claude.md §18)
  color: #A85B00;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  &:hover {
    text-decoration: underline;
  }
}
@media (max-width: 600px) {
  .banner-leaseback {
    font-size: 13px;
  }
}
</style>
